import React, { useState, useEffect } from 'react';
// router
import { Routes, Route } from 'react-router-dom';
import Preloader from "./widget/preloader";
import Navigation from "./widget/navigation";
import Footer from "./widget/footer";
import Home from "./pages/home";
import Privacy from "./pages/privacy";
import DeletePolicy from "./pages/delete_policy";
import Terms from "./pages/terms";
import Nopage from "./pages/nopage";
import Industries from "./widget/industries";
import Contact from './pages/contact';
import Services from './widget/services';
import About from './widget/aboutus';
import FeaturedProducts from './widget/featuredproducts';



function App() {
  return (
    <>
      <Preloader />
      <Navigation />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-policy" element={<DeletePolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/featured-products" element={<FeaturedProducts />} />
        <Route path="*" element={<Nopage />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;